import { createRoot } from "@wordpress/element";
import App from "./components/App";

import "@/utils/i18n";

document
	.querySelectorAll(".wp-block-weather-weather-prevision-description")
	.forEach((el) => {
		const root = el.querySelector(".weather-prevision-description__app");
		if (root) {
			createRoot(root).render(<App />);
		}
	});
